import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from './Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

function AdminPage() {
  const [category, setCategory] = useState('');
  const [filteredGrievances, setFilteredGrievances] = useState([]);
  const categories = ['Street', 'Road', 'Lights', 'Water', 'Trash', 'Parks', 'Noise'];
  const navigate = useNavigate();

  useEffect(() => {
    if (category) {
      db.collection('grievances')
        .where('category', '==', category)
        .get()
        .then((querySnapshot) => {
          const grievances = [];
          querySnapshot.forEach((doc) => {
            grievances.push({ id: doc.id, ...doc.data() });
          });
          setFilteredGrievances(grievances);
        })
        .catch((error) => {
          console.error('Error fetching grievances:', error);
        });
    }
  }, [category]);
  
  useEffect(()=>{
    if(localStorage.getItem("adminauth") ===null){
      navigate("/adminlogin");
    }
  },[])
  
  function deleteGrievance(id){
    try {
       db.collection('grievances').doc(id).delete();
       setFilteredGrievances(filteredGrievances.filter((grievance) => grievance.id !== id));
    } catch (error) {
      console.error('Error deleting grievance: ', error);
    }
  }

  


  return (
    <div className="admin-page-container">
      <h2 className="admin-header">Admin Page</h2>
      <label>
        Filter by Category:
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="category-select"
        >
          <option value="">Select a category</option>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </label>

      {category && (
        <div className="filtered-grievances-container">
          <h3 className="category-header">Grievances in Category: {category}</h3>
          {filteredGrievances.length==0?(<h4>nothing to show</h4>):(<ul className="grievances-list">
            {filteredGrievances.map((grievance, index) => (
              <li key={grievance.id} className="grievance-item">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="index-badge">{index + 1}</div>
              <div><button onClick={()=>deleteGrievance(grievance.id)} style={{backgroundColor:"white" , color:"red" , width:"15px" , marginBottom:"4px"}}><FontAwesomeIcon icon={faTrash}/></button></div>
            </div>
                <div className="address-label" style={{display:"flex"}}>Person : &nbsp;<div style={{color:"grey"}}>{grievance.name}</div></div>
                <div className="address-label" style={{display:"flex"}}>Phone No : &nbsp;<div style={{color:"grey"}}>{grievance.phoneNumber}</div></div>
                <strong className="address-label">Address:</strong> {grievance.address}
                <br />
                <br />
                <strong className="description-label">Description:</strong> {grievance.description}
              </li>
            ))}
          </ul>)}
        </div>
      )}
    </div>
  );
}

export default AdminPage;
